import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import errorToast from "../toast/errorToast";
import { fieldLabel } from "../../utils/form-validation";

const firstMessage = (error) => {
  if (typeof error === "string") return error;
  if (Array.isArray(error)) return error.map(firstMessage).find(Boolean);
  if (error && typeof error === "object") {
    return Object.values(error).map(firstMessage).find(Boolean);
  }
  return null;
};

// After a failed submit, list every invalid field in a toast and scroll to
// the first one, since on long forms the inline error can be off screen.
const FormErrorSummary = () => {
  const { submitCount, isSubmitting, isValid, errors } = useFormikContext();
  const handledCount = useRef(0);

  useEffect(() => {
    if (isSubmitting || isValid || submitCount === handledCount.current) {
      return;
    }
    handledCount.current = submitCount;

    const names = Object.keys(errors);
    if (names.length === 0) return;

    errorToast(
      <div>
        <p className="font-semibold">Please fix the following fields:</p>
        <ul className="list-disc ps-4">
          {names.map((name) => (
            <li key={name}>{firstMessage(errors[name]) || fieldLabel(name)}</li>
          ))}
        </ul>
      </div>,
    );

    const element =
      document.getElementById(names[0]) ||
      document.querySelector(`[name="${names[0]}"]`);
    element?.scrollIntoView({ behavior: "smooth", block: "center" });
    element?.focus?.({ preventScroll: true });
  }, [submitCount, isSubmitting, isValid, errors]);

  return null;
};

export default FormErrorSummary;
